import { JSX } from "solid-js";
import c from "class-c";

import styles from "./ChipContainer.module.scss";

declare namespace ChipContainer {
  type Props = {
    class?: string;
    children: JSX.Element;
  };
}

function ChipContainer({
  class: className,
  children,
  ...props
}: D<ChipContainer.Props>) {
  return (
    <div class={c`${styles["chip"]} ${className}`} {...props}>
      {children}
    </div>
  );
}

export default ChipContainer;
